export const ABSENT_VALUE = '—';

export function formatRate(percent: number): string {
  return `${percent.toFixed(2)}%`;
}

export function formatMeasuredValue(label: string, value: number | null): string {
  return value === null ? ABSENT_VALUE : `${value} ${label}`;
}
